'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('PathUtils');
module.exports = require('./index.js').PathUtils;



/*****************
 ** WEBPACK FOOTER
 ** ./~/history/PathUtils.js
 ** module id = 623
 ** module chunks = 0
 **/